export default __webpack_public_path__ + "static/media/in_yong_jung.a6ef98b2.png";